'use client';

import React from 'react';
import { Button, Text } from '@skin-seoul/design-system';
import LucideIcon from '@/components/ui/LucideIcon';
interface MobileSortButtonProps {
  onClick: () => void;
}
const MobileSortButton = ({
  onClick
}: MobileSortButtonProps) => {
  return <Button variant="outline" size="sm" width="100%" height="44px" textStyle="paragraph.small" padding={3} border="1px solid" borderColor="neutral.100" borderRadius="8px" color="neutral.600" fontWeight="regular" justifyContent="center" onClick={onClick} gap={2} data-sentry-element="Button" data-sentry-component="MobileSortButton" data-sentry-source-file="MobileSortButton.tsx">
      <LucideIcon name="ArrowDownUp" boxSize={5} data-sentry-element="LucideIcon" data-sentry-source-file="MobileSortButton.tsx" />
      <Text textStyle="paragraph.small" data-sentry-element="Text" data-sentry-source-file="MobileSortButton.tsx">Sort</Text>
    </Button>;
};
export default MobileSortButton;